import React from 'react';
import ContentCard from '../ContentCard';

const ThirdParties = () => {
  return <div className='left-align'>
      <ContentCard title="When and with whom might Stack Privacy share your personal information?"
          content={ <>
          
            <p>We may disclose your personal information to the following categories of recipients:</p>
          
            <ul style={{ marginLeft: '20px' }}> 
            <li>Third party services providers and partners who provide services to us.</li>
            <li>To any competent law enforcement body, regulator, government agency, court or other third party where we believe disclosure is necessary: (i) as a matter of applicable law or regulation, (ii) to exercise, establish or defend our legal rights, or (iii) to protect your vital interests or those of any other person; and</li> 
            <li>To a person you have given us your consent to disclose to.</li>
            </ul>
            </>
          }
            />


  </div>;
};

export default ThirdParties;